import store from "@/store";
import { GroupState } from "@/types/group";
import { computed, onMounted, onUnmounted } from "vue";
const useActiveTeams = () => {
    onMounted(async () => await store.dispatch.teams.subscribe(GroupState.Active));
    onUnmounted(async () => await store.dispatch.teams.unsubscribe(GroupState.Active));
    return {
        activeTeams: computed(() => store.state.teams.active),
        activeTeamsDataReceived: computed(() => store.state.teams.dataReceived.active)
    };
};
const useWaitingTeams = () => {
    onMounted(async () => await store.dispatch.teams.subscribe(GroupState.Waiting));
    onUnmounted(async () => await store.dispatch.teams.unsubscribe(GroupState.Waiting));
    return {
        waitingTeams: computed(() => store.state.teams.waiting),
        waitingTeamsDataReceived: computed(() => store.state.teams.dataReceived.waiting)
    };
};
const useFinishedTeams = () => {
    onMounted(async () => await store.dispatch.teams.subscribe(GroupState.Finished));
    onUnmounted(async () => await store.dispatch.teams.unsubscribe(GroupState.Finished));
    return {
        finishedTeams: computed(() => store.state.teams.finished),
        finishedTeamsDatReceived: computed(() => store.state.teams.dataReceived.finished)
    };
};
const useArchivedTeams = () => {
    onMounted(async () => await store.dispatch.teams.subscribe(GroupState.Archived));
    onUnmounted(async () => await store.dispatch.teams.unsubscribe(GroupState.Archived));
    return {
        archivedTeams: computed(() => store.state.teams.archived),
        archivedTeamsDataReceived: computed(() => store.state.teams.dataReceived.archived)
    };
};
const useAllTeams = () => {
    return {
        ...useActiveTeams(),
        ...useWaitingTeams(),
        ...useFinishedTeams()
    };
};
const useTeams = () => {
    return {
        createTeam: async (newTeam) => await store.dispatch.teams.add(newTeam),
        updateTeam: async (team) => await store.dispatch.teams.update(team),
        deleteTeam: async (teamId) => await store.dispatch.teams.delete(teamId)
    };
};
export { useTeams, useActiveTeams, useWaitingTeams, useFinishedTeams, useArchivedTeams, useAllTeams };
